import { MfaStartEnrollmentResponse } from "@shared/types/common";
import json from "../../json/userProfile/mfaStartEnrollment.json";

export default async () => {
  return JSON.parse(JSON.stringify(json)) as MfaStartEnrollmentResponse;
};
